import React, { forwardRef } from 'react';
import cn from 'classnames';
import styles from './Table.module.scss';

const Table = forwardRef(
  ({ className, tableLayout = 'fixed', ...props }, ref) => {
    const { style, ...restProps } = props;

    return (
      <table
        {...restProps}
        style={{ tableLayout: tableLayout, ...style }}
        ref={ref}
        className={cn(styles.root, className)}
      />
    );
  }
);

export default Table;
